module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive-52d4f4c368ac7c23c37ac245730fe007.png";